/*
  DORVETTI — Favoritos (2026-09-27). Sin apps: la lista se guarda en este navegador (localStorage,
  clave «dv-wishlist», handles de producto). Cualquier botón [data-dv-wish="handle"] la alterna;
  [data-dv-wish-count] muestra el número; la página de favoritos la pinta (dorvetti-wishlist.liquid).
  MOV-028: si el botón lleva data-dv-wish-item (JSON con name, desc e img), se guarda esa ficha en
  «dv-wishlist-items»: así una pieza aún sin publicar (borrador, sin /products/handle.js) también
  aparece en la página de favoritos.
  MOV-029: los favoritos exigen cuenta. Sin sesión, el corazón (y el del header) abre el aviso
  «Save to wishlist» (snippets/dorvetti-wish-modal). Con sesión, la lista se guarda por cliente
  («dv-wishlist:<id>»); lo guardado antes sin sesión pasa a la cuenta la primera vez que se entra.
*/
(() => {
  'use strict';
  if (window.DvWishlist) return;
  const customer = document.documentElement.dataset.dvCustomer || '';
  const loggedIn = customer !== '';
  const BASE = 'dv-wishlist';
  const KEY = loggedIn ? `${BASE}:${customer}` : BASE;
  const ITEMS = loggedIn ? `${BASE}-items:${customer}` : `${BASE}-items`;

  if (loggedIn) {
    try {
      if (localStorage.getItem(KEY) === null && localStorage.getItem(BASE) !== null) {
        localStorage.setItem(KEY, localStorage.getItem(BASE));
        const legacyItems = localStorage.getItem(`${BASE}-items`);
        if (legacyItems !== null) localStorage.setItem(ITEMS, legacyItems);
        localStorage.removeItem(BASE);
        localStorage.removeItem(`${BASE}-items`);
      }
    } catch (error) {
      /* sin almacenamiento: no hay nada que migrar */
    }
  }

  const read = () => {
    if (!loggedIn) return [];
    try {
      const list = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(list) ? list.filter((h) => typeof h === 'string') : [];
    } catch (error) {
      return [];
    }
  };

  const write = (list) => {
    try {
      localStorage.setItem(KEY, JSON.stringify(list.slice(0, 100)));
    } catch (error) {
      /* almacenamiento no disponible: la sesión sigue funcionando sin guardar */
    }
  };

  const readItems = () => {
    if (!loggedIn) return {};
    try {
      const items = JSON.parse(localStorage.getItem(ITEMS) || '{}');
      return items && typeof items === 'object' && !Array.isArray(items) ? items : {};
    } catch (error) {
      return {};
    }
  };

  const writeItems = (items) => {
    try {
      localStorage.setItem(ITEMS, JSON.stringify(items));
    } catch (error) {
      /* sin almacenamiento: la ficha no se guarda */
    }
  };

  // Ficha de una pieza sin publicar: solo textos y una URL https de imagen.
  const parseItem = (raw) => {
    if (!raw) return null;
    try {
      const data = JSON.parse(raw);
      const text = (value) => (typeof value === 'string' ? value.slice(0, 200) : '');
      const img = text(data.img);
      return { name: text(data.name), desc: text(data.desc), img: img.startsWith('https://') ? img : '' };
    } catch (error) {
      return null;
    }
  };

  const sync = () => {
    const list = read();
    document.querySelectorAll('[data-dv-wish]').forEach((button) => {
      const saved = list.includes(button.dataset.dvWish);
      button.setAttribute('aria-pressed', String(saved));
    });
    document.querySelectorAll('[data-dv-wish-count]').forEach((badge) => {
      badge.textContent = String(list.length);
      badge.hidden = list.length === 0;
    });
  };

  const toggle = (handle, item) => {
    let list = read();
    const adding = !list.includes(handle);
    list = adding ? [handle, ...list] : list.filter((entry) => entry !== handle);
    write(list);
    const items = readItems();
    if (adding && item) items[handle] = item;
    Object.keys(items).forEach((key) => {
      if (!list.includes(key)) delete items[key];
    });
    writeItems(items);
    sync();
    document.dispatchEvent(new CustomEvent('dv:wishlist', { detail: { list } }));
    return list.includes(handle);
  };

  // Aviso para quien no ha iniciado sesión. Sin <dialog> nativo, se va directo a iniciar sesión.
  const openModal = () => {
    const dialog = document.getElementById('DvWishModal');
    if (!dialog) return false;
    if (typeof dialog.showModal !== 'function') {
      const login = dialog.querySelector('.dv-wishmodal__btn--outline');
      if (login) window.location.href = login.href;
      return true;
    }
    if (!dialog.open) dialog.showModal();
    return true;
  };

  document.addEventListener('click', (event) => {
    const closer = event.target.closest('[data-dv-wishmodal-close]');
    if (closer) {
      closer.closest('dialog')?.close();
      return;
    }
    if (event.target instanceof HTMLDialogElement && event.target.id === 'DvWishModal') {
      event.target.close(); // clic en el fondo
      return;
    }
    const link = event.target.closest('[data-dv-wish-link]');
    if (link && !loggedIn && openModal()) {
      event.preventDefault();
      return;
    }
    const button = event.target.closest('[data-dv-wish]');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    if (!loggedIn) {
      openModal();
      return;
    }
    toggle(button.dataset.dvWish, parseItem(button.dataset.dvWishItem));
  });

  window.addEventListener('storage', (event) => {
    if (event.key === KEY) sync();
  });
  document.addEventListener('shopify:section:load', sync);

  window.DvWishlist = { read, write, readItems, sync, toggle, loggedIn, openModal };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync, { once: true });
  else sync();
})();
